import React from "react";
import { Modal, Button, Table, Form } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";
import moment from "moment";

import 'react-calendar/dist/Calendar.css';
import Calendar from 'react-calendar';

import { goTo, handleResultData } from "presentation/utils/functions/generic";

import eventInfosService from "presentation/services/event-infos";
import classroomStudentsService from "presentation/services/classroom-students";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

class SelectClassroomAttendanceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filterForm: {},
            selectedItem: null,
            academicPeriodDates: [],
            validDates: [],
            data: []
        };

        this.tBodyRef = React.createRef(null);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const { academicPeriodId } = this.props;
        this.setState({ loading: true });

        await eventInfosService.getSchoolDays(academicPeriodId).then((result) => {
            let handledResult = handleResultData(result);
            if (!handledResult.error) {
                let validDates = handledResult.map(x => { return moment(x.startDate).format("YYYY-MM-DD") });
                this.setState({ academicPeriodDates: handledResult, validDates: validDates });
            }

            this.setState({ loading: false });
        });
    }


    dateIsDisabled = (dateInformation) => {
        const { validDates } = this.state;
        let checkDate = moment(dateInformation.date).format("YYYY-MM-DD");
        return !validDates.includes(checkDate);
    }

    onChangeDate = (value, event) => {
        const { academicPeriodDates } = this.state;

        let existing = academicPeriodDates.filter(x => moment(x.startDate).format("YYYY-MM-DD") == moment(value).format("YYYY-MM-DD"))[0];
        this.setState({ selectedItem: existing.id });
    }


    onSubmit = async () => {

        let { classroomId, component } = this.props;
        let { selectedItem } = this.state;

        this.setState({ loading: true, error: '' });


        if (!selectedItem) {
            this.setState({ loading: false, error: true, message: "Por favor, selecione uma data..." });
        } else {
            let targetUrl = `/turmas/${classroomId}/frequencia-por-dia/${selectedItem}`;
            goTo(targetUrl, component);
        }
    };

    render() {
        let { show, onClose, classroomName, component } = this.props;
        let { loading, selectedItem, error, message, validDates } = this.state;
        const { searchData, onSubmit, tBodyRef, dateIsDisabled, onChangeDate } = this;
        const hasSelection = !(selectedItem == null);
        return (
            <Modal size="lg" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{classroomName} / Registro de Frequência por dia</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                    {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                    {loading === false && (
                        <div className="react-calendar-container">
                            {validDates.length > 0 && <Calendar
                                locale="pt-BR"
                                tileDisabled={dateIsDisabled}
                                onChange={(value, event) => onChangeDate(value, event)}
                            />}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <Button disabled={loading || !hasSelection} variant="success" onClick={() => onSubmit()}>
                        Iniciar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
}

export default SelectClassroomAttendanceModal;